
import React from 'react';
import { Button } from "@/components/ui/button";
import { X } from 'lucide-react';
import BrandLogo from "../BrandLogo";

interface MobileMenuButtonProps {
  mounted: boolean;
  theme: string | undefined;
  onThemeToggle: () => void;
  isOpen: boolean;
  onToggle: () => void;
}

export const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({
  isOpen,
  onToggle
}) => {
  return (
    <div className="flex items-center ml-2">
      <Button
        variant="ghost"
        size="icon"
        onClick={onToggle}
        className="w-12 h-12 p-0 flex items-center justify-center rounded-full md:w-10 md:h-10"
        aria-label={isOpen ? "Close mobile menu" : "Open mobile menu"}
        aria-pressed={isOpen}
        aria-haspopup="true"
        aria-controls="mobile-navigation"
        style={{ 
          minWidth: 44, 
          minHeight: 44, 
          touchAction: 'manipulation'
        }}
      >
        {isOpen ? (
          <X className="h-7 w-7" aria-hidden="true" />
        ) : (
          <BrandLogo variant="icon" size={28} className="opacity-90 hover:opacity-100 transition-opacity" />
        )}
      </Button>
    </div>
  );
};
